import storagePlanActionTypes from './subscription-plan-action-types';
import { authorizedRequest } from '../../common/request';
import paymentAccountActionTypes from './payment-accounts-action-types';
import {setRemoteLoading} from '../../settings/actions/application-actions';
const subscriptionWebApiBasePath = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/subscription`;

export const
  productsRequest = () => authorizedRequest(`${subscriptionWebApiBasePath}/products`, null, 'GET', false, false),
  profileRequest = () => authorizedRequest(`${subscriptionWebApiBasePath}/profile`, null, 'GET', false, false),
  paymentAccountsRequest = (currencyCode) => authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/payacct?currencyCode=${currencyCode==null?'USD':currencyCode}`, null, 'GET', false, false),
  getSharesRequest = () => authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/shares`, null, 'GET', false, false),
  discsRequest = () => authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/discpkg?format=fast&max=1`, null, 'GET', false, false);

export const initializeStoragePlanManagementPage = (dispatch, preferredCurrencyCode) => {
  // first we need to request the user's subscription profile so that if they are VIP, expired, or bad payment we do not make any unnecessary requests
  dispatch(setRemoteLoading(true));
  profileRequest().then(subscriptionProfile => {
    dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PROFILE_RECEIVED, subscriptionProfile });

    // if (subscriptionProfile && subscriptionProfile.subscriptionProfileType === 'VIP') {
    //   dispatch(setRemoteLoading(false));
    // } else {
    {
      return Promise.all([productsRequest(), paymentAccountsRequest(preferredCurrencyCode), getSharesRequest(), discsRequest()]).then(responses => {
        const [ productsResponse, paymentAccountsResponse, sharesResponse, discsResponse ] = responses;
        dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PLANS_RECEIVED, subscriptionPlans: productsResponse });
        dispatch({ type: storagePlanActionTypes.SET_SHARES_COUNT, sharesCount: sharesResponse.count });
        dispatch({ type: storagePlanActionTypes.SET_DISCS_COUNT, discsCount: discsResponse.count });

        if (Object.keys(paymentAccountsResponse).length > 0) {
          const primaryPaymentAcct = paymentAccountsResponse.find(paymentAcct =>  paymentAcct.primaryYn === 'Y');
          if (primaryPaymentAcct) {
            dispatch({
              type: paymentAccountActionTypes.SET_PAYMENT_ACCOUNTS_WITH_PRIMARY,
              payload: { paymentAccounts: paymentAccountsResponse, primaryPaymentAcct }});
          } else {
            dispatch({
              type: paymentAccountActionTypes.SET_PAYMENT_ACCOUNTS,
              payload: { paymentAccounts: paymentAccountsResponse }});
          }
        }
        dispatch(setRemoteLoading(false));
      }).catch(err => {
        console.log(err);
        dispatch(setRemoteLoading(false));
      });
    }
  }).catch(err => console.log(err));
  return { type: 'INITIALIZE_STORAGE_PLAN_MANAGEMENT' };
};

export const setSelectedSubscriptionRadio = subscriptionPlanRadioSelected =>
  ({ type: storagePlanActionTypes.SET_SELECTED_SUBSCRIPTION_RADIO, subscriptionPlanRadioSelected });

export const getSubscriptionPlans = dispatch => {
  authorizedRequest(`${subscriptionWebApiBasePath}/products`).then(res => {
    dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PLANS_RECEIVED, subscriptionPlans: res });
  }).catch(err => {
    dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PLANS_FAILED });
  });

  return {
    type: 'SUBSCRIPTION_PLANS_REQUESTED'
  };
};

export const getSubscriptionProfile = dispatch => {
  authorizedRequest(`${subscriptionWebApiBasePath}/profile`).then(res => {
    dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PROFILE_RECEIVED, subscriptionProfile: res });
  }).catch(err => {
    dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PROFILE_FAILED });
  });

  return {
    type: 'SUBSCRIPTION_PROFILE_REQUESTED'
  };
};

export const newSubscription = (rpcProductId, paymentAccountId, dispatch) => {
  newSubscriptionRequest(rpcProductId, paymentAccountId)
    .then(res => {
      dispatch(subscriptionProfileReceived(res));
    }).catch(err => {
      console.log(err);
      dispatch(subscriptionProfileFailure());
  });

  return {
    type: 'NEW_SUBSCRIPTION_POST'
  };
};

export const newSubscriptionRequest = (rpcProductId, paymentAccountId) => {
   return authorizedRequest(`${subscriptionWebApiBasePath}/subscribe`, {rpcProductId, paymentAccountId}, 'POST');
}

export const subscriptionProfileReceived = subscriptionProfile => ({ type: storagePlanActionTypes.SUBSCRIPTION_PROFILE_RECEIVED, subscriptionProfile });

export const subscriptionProfileFailure = () => ({ type: storagePlanActionTypes.NEW_SUBSCRIPTION_FAILURE });

export const cancelSubscription = dispatch => {
  authorizedRequest(`${subscriptionWebApiBasePath}/cancel`, {}, 'DELETE')
    .then(updatedProfile => {
      dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_PROFILE_RECEIVED, subscriptionProfile: updatedProfile });
    }).catch(err => {
      console.log(err);
    dispatch({ type: storagePlanActionTypes.SUBSCRIPTION_CANCEL_FAILED });
  });

  return {
    type: 'CANCEL_SUBSCRIPTION_REQUEST'
  };
};
export const setSubscriptionPaymentAccount = (dispatch, paymentAccountId) => {
  authorizedRequest(`${subscriptionWebApiBasePath}/paymentAccount`, {paymentAccountId: paymentAccountId}, 'PUT')
      .then(updatedProfile => {
        if(updatedProfile != null && typeof(updatedProfile.errorMessage) !== "undefined"){
          alert(updateProfile.errorMessage);
        }else {
            getSubscriptionProfile(dispatch);
            dispatch({type: storagePlanActionTypes.SUBSCRIPTION_PROFILE_RECEIVED, subscriptionProfile: updatedProfile});
        }
      })  .catch(err => {
        alert(err);
      });
  return {
    type: storagePlanActionTypes.SUBSCRIPTION_SET_PAYMENT_ACCOUNT
  }

}


// WEBPACK FOOTER //
// ./src/account/actions/subscription-plan-actions.js